module.exports = __webpack_public_path__ + "src/assets/models/injection/syringes/syringe_4.fbx";